var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreenBlack24Dp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36.667 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fullscreen_black_24dp_svg__Path_875",
    x: 0,
    y: 0.667,
    width: 36.667,
    height: 36.667,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fullscreen_black_24dp_svg__fullscreen_black_24dp",
    transform: "translate(2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullscreen_black_24dp_svg__Path_874",
    "data-name": "Path 874",
    d: "M0,0H32V32H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.33, 0)",
    filter: "url(#fullscreen_black_24dp_svg__Path_875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fullscreen_black_24dp_svg__Path_875-2",
    "data-name": "Path 875",
    d: "M7.667,17H5v6.667h6.667V21h-4ZM5,11.667H7.667v-4h4V5H5ZM21,21H17v2.667h6.667V17H21ZM17,5V7.667h4v4h2.667V5Z",
    transform: "translate(4 1.67)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenBlack24Dp);
export default __webpack_public_path__ + "static/media/fullscreen_black_24dp.27bce93198b22333ea5e4018de3cf170.svg";
export { ForwardRef as ReactComponent };